import { SecuritiesInList } from "..";
import { Security } from "../../../store/types";

interface FilterSecuritiesParams {
  securities: SecuritiesInList;
  filter: string;
}

export const filterSecurities = ({ securities, filter }: FilterSecuritiesParams) => {
  const securitiesCopy = { ...securities };
  const searchCriteria = filter.toLowerCase().trim();

  const securitiesFiltered = Object.keys(securitiesCopy).reduce((acc, isin) => {
    const security: Security = securitiesCopy[isin];

    const { name, isin: isinValue, alias } = security;

    if ([name, isinValue, alias].some((value) => value.toLowerCase().includes(searchCriteria))) {
      return {
        ...acc,
        [isin]: security,
      };
    }

    return acc;
  }, {});

  return securitiesFiltered;
};
